import { NavLink } from 'react-router-dom'
import getAll from 'utils/getAll'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'
import capitalize from 'utils/capitalize'
import { IonIcon } from '@ionic/react'
import { lockOpenOutline } from 'ionicons/icons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
  unlockAccount: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(apiUrls.superadmins)

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].action = (
      <ActionButtons
        buttons={[
          {
            type: 'u',
            url: '/edit-superadmin/' + row.id,
          },
          {
            type: 'p',
            id: dataArray[index].id,
            url: '/change-password-superadmin/' + row.id,
          },
          {
            content: (
              <NavLink
                to='#'
                title='Unlock Account for Login'
                onClick={(e) => {
                  props.unlockAccount(row.id)
                }}
              >
                <IonIcon icon={lockOpenOutline} className='ionicon' style={{ fontSize: '16px' }} />
              </NavLink>
            ),
          },
          {
            type: 'd',
            id: dataArray[index].id,
            url: '/delete-superadmin/' + row.id,
            setDeleteEntryId: props.setDeleteEntryId,
            setShowModal: props.setShowModal,
          },
        ]}
      />
    )
    dataArray[index].email_reports = dataArray[index].email_reports === 1 ? 'Yes' : 'No'
    dataArray[index].status = capitalize(dataArray[index].status)
  })

  return data
}

export default getRows
